const ruleMap = {
  origin: /^(https|http){0,1}(:\/\/){0,1}([a-zA-Z0-9]+[.]*){1,}([:][0-9]+){0,1}/g,
  protocol: /^([a-zA-Z]+)(?=:\/\/)/g,
  host: /([a-zA-Z0-9]+[.]){1,}([a-zA-Z]+)([:][0-9]+){0,1}/g,
  hostname: /([a-zA-Z0-9]+[.])+[a-zA-Z0-9]+/g,
  port: /(?=:)[0-9]{1,}/g,
}

const convertToString = v => {
  try {
    return JSON.stringify(v)
  } catch (e) {
    throw new Error('请确保参数格式正确')
  }
}

const getMatchResultByKey = (url, key) => {
  const matches = url.match(ruleMap[key])
  return matches ? matches[0] : ''
}

export const getOrigin = url => getMatchResultByKey(url, 'origin')

export const getProtocol = url => getMatchResultByKey(url, 'protocol')

export const getHost = url => getMatchResultByKey(url, 'host')

export const getHostName = url => getMatchResultByKey(url, 'hostname')

export const getPort = url => getMatchResultByKey(url, 'port')

export const addQuery = location => (key, value) => {
  const { origin, pathname, search } = location
  let newSearch = ''
  let newLocation = {}

  if (search.indexOf(`${key}=`) < 0) {
    newSearch = `${search}${
      search === '?' || !search ? '?' : '&'
    }${key}=${convertToString(value)}`
  } else {
    const oldSearchArr = search.replace('?', '').split(/&|=/)
    newSearch = '?'
    oldSearchArr.forEach((item, i) => {
      if (i % 2 === 0) {
        newSearch = `${newSearch}${i === 0 ? '' : '&'}${item}=`
      } else {
        newSearch = `${newSearch}${
          oldSearchArr[i - 1] === key ? convertToString(value) : item
        }`
      }
    })
  }

  newLocation = {
    ...location,
    href: `${origin}${pathname}${newSearch}`,
    search: newSearch,
  }

  return newLocation
}

export const isEqual = location => location2 =>
  `${location.origin}${location.pathname}${location.search}` ===
  `${location2.origin}${location2.pathname}${location2.search}`

const generateLocation = url => {
  const location = Object.keys(ruleMap).reduce(
    (result, key) => ({
      ...result,
      [key]: getMatchResultByKey(url, key),
    }),
    {}
  )
  const remainUrl = url.replace(location.origin, '')
  const remainUrlArr = remainUrl.split('?')

  return {
    href: url,
    ...location,
    pathname: remainUrlArr[0],
    search: remainUrlArr[1] ? `?${remainUrlArr[1]}` : '',
  }
}

const generateFunctions = location => {
  return {
    addQuery: addQuery(location),
    isEqual: isEqual(location),
  }
}

const parsedUrl = url => {
  const location = generateLocation(url)
  return {
    ...location,
    ...generateFunctions(location),
  }
}

export default parsedUrl



// WEBPACK FOOTER //
// ./src/utils/urlParser.js